module.exports = __webpack_public_path__ + "static/camerons-d75823912315bd5d264e681c7e928501.jpg";